/**
 * Automação do Instagram no Hoje ao vivo (`GET /api/painel/automacao-resumo`, dono 29/10/2026): por dia
 * de São Paulo, as vendas que a automação trouxe (a regra do servidor: pedido pago com o marcador do
 * contato ou o link da automação), o faturamento delas (valor do produto, sem juros), o custo da IA do
 * direct e dos comentários em real e o lucro; e o crédito da IA que resta no mês da Anthropic.
 * Nada vem da simulação: sem resposta, o cartão mostra o erro (nunca números inventados).
 */
import type { AutomationSummary, ProviderError, Query } from '@rota/contracts';
import { getWithRetry } from './http';
import { type RealCtx, type RealModule, rangeMs } from './realCore';

export async function fetchAutomationSummary(
  from: number,
  to: number,
  get: (url: string) => Promise<Response> = getWithRetry,
): Promise<AutomationSummary> {
  const r = await get(`/api/painel/automacao-resumo?from=${from}&to=${to}`);
  if (!r.ok) {
    const err: ProviderError = {
      code: r.status === 403 ? 'forbidden' : 'source_unavailable',
      message:
        r.status === 403
          ? 'Sem acesso aos números da automação.'
          : `O servidor não respondeu (HTTP ${r.status}).`,
    };
    throw err;
  }
  return (await r.json()) as AutomationSummary;
}

export function automationModule(
  ctx: RealCtx,
  load: (from: number, to: number) => Promise<AutomationSummary> = fetchAutomationSummary,
): RealModule {
  return {
    overrides: {
      getAutomationSummary(q: Query) {
        const { from, to } = rangeMs(q, ctx.clock());
        return load(from, to);
      },
    },
  };
}
